import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

const generateId = () => `modal-${Math.random().toString(36).substring(7)}`;
const Portal = ({
  id,
  show,
  children,
  zIndex
}) => {
  const [elmRef, setElmRef] = useState();
  const [modalId, setModalId] = useState(null);
  useEffect(() => {
    const elm = modalId ? document.getElementById(modalId) : null;
    if (!show) {
      if (elm) {
        setTimeout(() => {
          document.body.style.overflow = "";
          document.body.style.width = "";
          elm.style.display = "none";
        }, 200);
      }
      return;
    }
    if (elm) {
      document.body.style.overflow = "hidden";
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.width = `calc(100% - ${scrollbarWidth}px)`;
      elm.style.display = "flex";
      setElmRef(elm);
    } else {
      const elm2 = document.createElement("div");
      elm2.id = id || generateId();
      setModalId(elm2.id);
      elm2.style.position = "fixed";
      elm2.style.top = "0";
      elm2.style.left = "0";
      elm2.style.right = "0";
      elm2.style.bottom = "0";
      elm2.style.zIndex = (zIndex == null ? void 0 : zIndex.toString()) || "1050";
      elm2.style.justifyContent = "center";
      elm2.style.alignItems = "center";
      document.body.appendChild(elm2);
    }
  }, [show, modalId, id, zIndex]);
  if (!elmRef)
    return null;
  return ReactDOM.createPortal(children, elmRef);
};

export { Portal };
